import { render, staticRenderFns } from "./UiLoginCtrl.vue?vue&type=template&id=1d81b198&scoped=true&"
import script from "./UiLoginCtrl.vue?vue&type=script&lang=js&"
export * from "./UiLoginCtrl.vue?vue&type=script&lang=js&"
import style0 from "./UiLoginCtrl.vue?vue&type=style&index=0&id=1d81b198&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81b198",
  null
  
)

export default component.exports